/**
 * Hydration from the persisted Smart Chart note should fill an empty Additional
 * EHR Context draft, but it must not replace a draft the user (or Interval
 * History insert) already changed.
 */
export const shouldReplaceAdditionalContextDraft = (
  currentDraft: unknown,
  persistedDraft: unknown
): boolean => {
  const current = String(currentDraft ?? "").trim();
  const persisted = String(persistedDraft ?? "").trim();
  return current.length === 0 || current === persisted;
};
